// De tekstregels staan in utils/seoAuto.ts, zodat het beheer precies dezelfde automatische tekst toont.
export { absoluteUrl, clampDescription, productDescription } from '../../utils/seoAuto'
export { SEO_DESCRIPTION_MAX as DESCRIPTION_MAX } from '../../core/rules/seo'

/** Een kapotte %-reeks in de URL mag de site niet laten crashen. */
export function safeDecode(s: string) {
  try {
    return decodeURIComponent(s)
  } catch {
    return s
  }
}
